<template>
  <div class="top-regional-container">
    <h1><img src="@/assets/Regional.svg" /></h1>
    <table class="top-regional">
      <thead>
        <tr>
          <th>Rank</th>
          <th>Player</th>
          <th>Region</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, index) in sortedRecords" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ value.player }}</td>
          <td>{{ value.region }}</td>
          <td>{{ value.score }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TopRegional',
  props: {
    records: Array
  },
  computed: {
    sortedRecords: function () {
      return this.records.slice().sort(function(a, b) {
        return a.score - b.score;
      }).reverse()
    }
  }
}
</script>

<style lang="scss" scoped>

h1 img {
  max-width: 600px;
}
table {
  border-collapse: collapse;
  font-size: 28px;
  font-weight: bold;
  margin: 0 auto;
  max-width: 1366px;
  text-transform: uppercase;
  width: 100%;
}
th, td {
  color: #fff;
}

thead {
  margin-bottom: 10px;
}

th {
  padding: 25px 0;
}

tbody tr {
  &:first-child {
    background: #74399D;
  }
}

td {
  font-size: 32px;
  padding: 10px 0;
}
</style>
